import axios from "axios";

// Public axios instance for the external signer page. Deliberately has
// NO auth interceptor and NO login-redirect behaviour — external signers
// are not app users; they authenticate with an email OTP and hold a
// short-lived signing token in memory only.
export const esignPublic = axios.create({
  baseURL: `${process.env.REACT_APP_BACKEND_URL}/api`,
  headers: { "Content-Type": "application/json" },
});

export const FIELD_META = {
  signature: { label: "Signature" },
  name: { label: "Full name" },
  address: { label: "Address" },
  date: { label: "Date" },
  deed_date: { label: "Date of deed" },
};

export const ROLE_LABELS = {
  transferor: "Transferor",
  transferee: "Transferee",
  borrower: "Borrower",
  lender: "Lender",
  landlord: "Landlord",
  tenant: "Tenant",
  other: "Other party",
};

export const PARTY_COLORS = [
  { border: "#2563eb", bg: "rgba(37,99,235,0.14)", text: "#1d4ed8" },
  { border: "#059669", bg: "rgba(5,150,105,0.14)", text: "#047857" },
  { border: "#d97706", bg: "rgba(217,119,6,0.14)", text: "#b45309" },
  { border: "#7c3aed", bg: "rgba(124,58,237,0.14)", text: "#6d28d9" },
  { border: "#db2777", bg: "rgba(219,39,119,0.14)", text: "#be185d" },
];

export const WITNESS_COLOR = { border: "#0891b2", bg: "rgba(8,145,178,0.14)", text: "#0e7490" };
export const SOLICITOR_COLOR = { border: "#475569", bg: "rgba(71,85,105,0.14)", text: "#334155" };
